@if (accountStatus != null) {
<div>
    <label class="header-label">Account status: </label>
    <td style="padding-left: 32px"><label style="font-size: 18px; font-size: 32px; font-weight: bold;" [style.color]="accountStatusColor">{{accountStatus}}</label></td>
    <p>
        <label style="font-size: 12px; margin-left: 20px;">Last payment:</label>
        <label style="font-size: 12px; margin-left: 20px;">{{lastPaymentDate}}</label>
        <label style="font-size: 12px; margin-left: 20px;" [style.color]="lastPaymentColor">{{lastPaymentMessage}}</label>
    </p>
</div>
@if (showSubscribeButton()) {
    <button (click)="onResubscribe()" class="subButton" mat-raised-button style="background-color: green;" [disabled]="fintechService.busy">Resubscribe</button>
}
@if (showUnsubscribeButton()) {
<button (click)="onUnsubscribe()" class="subButton" mat-raised-button style="background-color: green;" [disabled]="fintechService.busy">Unsubscribe</button>
}
<hr>
}
